<template>
    <pageInfo>
        <template slot="crumb">
            <crumb-nav></crumb-nav>
        </template>
        <template v-slot:content>
            <div class="apply-sale white-bg">
                <h3 class="name">申请售后</h3>
                <el-table
                        class="tab-list"
                        :data="orderData"
                        :cell-style="{'border-right':'1px solid #cdcdcd','text-align':'left','padding-left':'92px'}"
                        :header-row-style="{'background-color':'#EBF3EE','border':'1px solid #E0E0E0'}"
                        :header-cell-style="{
                          'background-color':'#EBF3EE',
                          'font-size':'14px',
                          'color':'#333333',
                          'height':'40px',
                          'padding':'0px',
                          'text-align':'left',
                          'font-weight':'500',
                          'border-right':'1px solid #cdcdcd',
                          'padding-left':'92px'
                      }"
                >
                    <el-table-column
                            label="店铺名称"
                            align="left"
                    >
                        <template slot-scope="prop">
                            <div>
                                <el-image class="goods-img" :src="$common.imgPath(prop.row.goodsLog)" :alt="prop.row.goodsName" lazy></el-image>
                                <span class="goods-name">{{prop.row.goodsName}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goodsNum"
                            label="数量"
                            width="300"
                            align="center">

                    </el-table-column>
                    <el-table-column
                            width="300"
                            label="价格"
                            align="center">
                        <template slot-scope="prop">
                            ¥ <span class="price">{{$common.number(prop.row.realPrice,2)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <h3 class="name">请选择退货原因</h3>
                <ul class="apply-list">
                    <li :ref="'checks'+index" :class="{'selected':list[index].isSelected}" v-for="(item,index) in list" :key="index" @click="chooseList(index)">
                        {{item.name}}
                        <span class="icon-gou"></span>
                        <i class="el-icon-check"></i>
                    </li>
                </ul>
                <h3 class="name"><span class="cell-red">*</span>  问题描述</h3>
                <el-input
                        class="inp-apply"
                        type="textarea"
                        :autosize="{ minRows: 5, maxRows: 10}"
                        placeholder="将具体情况告诉我们，我们将尽快解决此事"
                        v-model="applyReason"
                        resize="none"
                        maxlength="500"
                        show-word-limit>
                </el-input>
                <el-upload
                        class="apply-upload"
                        action
                        list-type="picture-card"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove">

                    <i class="icon-add el-icon-circle-plus-outline"></i>
                    <p class="add-tip">添加图片</p>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
                <button type="button" class="btn-main btn-small btn-apply" @click="commitApply()">申请售后</button>
            </div>
        </template>
    </pageInfo>

</template>
<script>
    import pageInfo from '../../layout/pageInfo/index.vue'
    import crumbNav from '../../../components/crumb/index.vue'
    import {findOrderInfo,returnOrderApply} from '../../../api/order'
    export default {
        data(){
            return {
                userInfo:JSON.parse(localStorage.getItem('user'))||null,//登录用户信息
                orderInfo:'',
                goodsInfo:'',
                orderData:[],
                applyReason:'',
                dialogImageUrl: '',
                dialogVisible: false,
                isSelected:false,
                list:[
                    {
                        id:0,
                        name:'包装坏了',
                        isSelected:false
                    },
                    {
                        id:1,
                        name:'漏东西了',
                        isSelected:false
                    },
                    {
                        id:2,
                        name:'物品损坏',
                        isSelected:false
                    },
                    {
                        id:3,
                        name:'不是正品',
                        isSelected:false
                    },
                    {
                        id:4,
                        name:'漏发',
                        isSelected:false
                    },
                    {
                        id:5,
                        name:'没有收到',
                        isSelected:false
                    },
                    {
                        id:6,
                        name:'有异味',
                        isSelected:false
                    },
                    {
                        id:7,
                        name:'无法使用',
                        isSelected:false
                    }
                ]
            }
        },
        components:{
            pageInfo,
            crumbNav
        },
        computed:{
            orderId(){
                return this.$route.params.orderId;
            }
        },
        created () {


        },
        mounted(){
            this.findOrderInfo();
        },
        methods:{
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            getMeUserInfo(){
                this.$store.dispatch('getMeInfoData').then(res=>{
                    this.userInfo=res.data.user;
                    this.totalMoney=res.data.user.account;
                }).catch(err=>err)
            },
            findOrderInfo(){
                findOrderInfo({
                    userId:this.userInfo.userId,
                    orderId:this.orderId
                }).then((res)=>{
                    this.addressInfo=res.data.address;
                    this.goodsInfo=res.data.goods;
                    this.orderInfo=res.data.order;
                    this.orderData=[{
                        goodsNum:this.orderInfo.goodsNum,
                        goodsName:this.goodsInfo.goodsName,
                        goodsLog:this.goodsInfo.goodsLog,
                        realPrice:this.orderInfo.realPrice
                    }];
                })
            },
            chooseList(ind) {
                this.list.forEach((item2, index) => {
                    if (index==ind) {
                        this.list[index].isSelected?this.list[index].isSelected=false:this.list[index].isSelected=true;
                    }
                });
            },
            commitApply(){
                let returnDesc;
                for(let i=0;i<this.list.length;i++){
                    if(this.list.isSelected){
                        returnDesc+=this.list.name
                    }
                }
                returnOrderApply({
                    userId:this.userInfo.userId,
                    orderId:this.orderId,
                    returnDesc,
                    returnImg:''
                }).then(()=>{
                    this.$message({
                        message:'提交成功',
                        type:'success'
                    });
                    this.$router.back();
                })
            }

        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../assets/css/common";
    .apply-sale{
       padding:30px 50px;
        .name{
            font-size:14px;
            color:#222;
        }
        .tab-list{
            margin:20px 0 40px;
            border:1px solid #E0E0E0;
            font-size:16px;
            .goods-img{width:100px;height:100px;
                vertical-align: middle;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;}
            .goods-name{
                padding-left:10px;
                vertical-align: middle;}
            .price{font-size:18px;font-weight:600}
        }
        .apply-list{
            height:34px;
            padding:20px 0 30px;
            li{
                &+li{margin-left:20px;}
                float: left;
                width:118px;
                height:32px;
                line-height:32px;
                text-align: center;
                font-size:16px;
                color:#333;
                cursor: pointer;
                position: relative;
                .icon-gou{
                    display: none;
                    position: absolute;
                    right:-1px;
                    bottom:0;
                    border-style: solid;
                    border-width: 0px 0px 22px 22px;
                    border-color: transparent transparent $main-color transparent;
                    width: 0px;
                    height: 0px;
                }
                .el-icon-check{
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    font-size: 7px;
                    color: #fff;
                }
                border:1px solid #E0E0E0;
                &.selected{
                    border:1px solid $main-color;
                    .icon-gou{display: block;}
                }
            }
        }
        .inp-apply{
            margin:20px 0;
            width:700px;
        }
        .btn-apply{
            margin:40px 0 192px;
            width:220px;
            height:48px;
            -webkit-border-radius: 4px;
            -moz-border-radius: 4px;
            border-radius: 4px;
            font-size:18px;
        }
    }
</style>
<style lang="scss">
    @import "../../../assets/css/common";

    .el-upload--picture-card{
        width:100px;
        height:78px;
        padding:15px 0;
        background:rgba(244,244,244,1);
        border:none;
        line-height:20px;
        color:#333;
        &:hover{color:#333;}
        .add-tip{
            font-size:12px;
        }
    }
</style>